import { cmsConfig } from '$lib/services/config';

import { detectGitbaseMode } from './mode';

/**
 * Initialize GitBase integrations (CDN bundle mode).
 */
export const initGitbase = () => {
  window.__GITBASE__ = true;

  if (typeof window === 'undefined') {
    return;
  }

  // Detect mode once CMS config is available (not at startup, when backend is still unknown).
  const unsubscribe = cmsConfig.subscribe((config) => {
    if (!config?.backend?.name) {
      return;
    }

    detectGitbaseMode().catch(() => {
      //
    });
    unsubscribe();
  });
};

export {
  detectGitbaseMode,
  getGitbaseMode,
  isGitbaseAdminSite,
  isGitbaseMode,
} from './mode';
export { onGitbaseSignIn, fetchGitbaseBootstrap } from './bootstrap';
export {
  getGitbaseApiKey,
  getGitbaseDeployHookURL,
  shouldGitbaseSkipCI,
  stripGitbasePrefsSecrets,
  mergeGitbasePrefsSecrets,
} from './session-secrets';
